export class Page {
  pageSize: number = 0;
  totalElements: number = 0;
  totalPages: number = 0;
  pageIndex: number = 0;
}
